import { CellSelection } from '../../../../../common/table/TableTypes';
import { parseCellName } from '../../utils/selectionUtils/tableSelectionExcelNameUtils';

type HighlightedCellColor = {
    borderColorHex: string;
    backgroundColor: string;
};

const HIGHLIGHTED_CELL_COLORS: HighlightedCellColor[] = [
    {
        // Blue
        borderColorHex: '16a0e5',
        backgroundColor: 'rgba(22, 160, 229, 0.1)',
    },
    {
        // Orange
        borderColorHex: 'ff8d22',
        backgroundColor: 'rgba(255, 141, 34, 0.1)',
    },
    {
        // Green
        borderColorHex: '4eb85a',
        backgroundColor: 'rgba(78, 184, 90, 0.1)',
    },
    {
        // Purple
        borderColorHex: 'af72ff',
        backgroundColor: 'rgba(175, 114, 255, 0.1)',
    },
    {
        // Pink
        borderColorHex: 'ff6dd4',
        backgroundColor: 'rgba(255, 109, 212, 0.1)',
    },
    {
        // Teal
        borderColorHex: '62dbc8',
        backgroundColor: 'rgba(98, 219, 200, 0.1)',
    },
];

type UncoloredCellReference = {
    cellSelection: CellSelection;
    cellSelectionName: string;
};

export type CellReference = UncoloredCellReference & HighlightedCellColor;

export const getCellReferences = (inputValue: string): CellReference[] => {
    const baseReferences = inputValue
        .replaceAll(' ', '')
        .split(/[=(),?*/^%&\-+<>;]/)
        .reduce<UncoloredCellReference[]>((acc, str) => {
            const cellSelection = parseCellName(str);

            if (cellSelection) acc.push({ cellSelection, cellSelectionName: str });

            return acc;
        }, []);

    return baseReferences.map((reference, index) => ({
        ...reference,
        ...HIGHLIGHTED_CELL_COLORS[index % HIGHLIGHTED_CELL_COLORS.length],
    }));
};

export const findCellReferenceBeforeSelection = (
    cellReferences: CellReference[],
    text: string,
    selectionStart: number,
): CellReference | undefined => {
    return cellReferences.find(
        ({ cellSelectionName }) =>
            text.slice(selectionStart - cellSelectionName.length, selectionStart) === cellSelectionName,
    );
};
